<template>
  <v-menu v-model="mostrar" :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon> mdi-dots-vertical </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
      v-if="mixValidaScopesActions(2)"
      @click="editarContrato" link>
        <v-list-item-icon>
          <v-icon> mdi-pencil </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> Editar </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
      v-if="mixValidaScopesActions(3)"
      @click="borrarContrato" link>
        <v-list-item-icon>
          <v-icon> mdi-delete </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> Borrar </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item
        v-for="(opcion, index) in opciones"
        :key="index"
        :to="{ name: opcion.ruta, params: { idContrato: contrato.id } }"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ opcion.nombre }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'OpcionesContratos',
  props: {
    contrato: Object,
  },
  data() {
    return {
      mostrar: false,
      opciones: [
        {
          nombre: 'Anticipos',
          ruta: 'contratoAnticipos',
          icono: '',
        },
        {
          nombre: 'Fianzas',
          ruta: 'contratoFianzas',
          icono: '',
        },
        {
          nombre: 'Convenios',
          ruta: 'contratoConvenios',
          icono: '',
        },
        {
          nombre: 'Catálogo',
          ruta: 'contratoCatalogo',
          icono: '',
        },
      ],
    };
  },
  methods: {
    editarContrato() {
      eventBus.$emit('editar-contrato', this.contrato);
    },
    borrarContrato() {
      eventBus.$emit('eliminar-contrato', this.contrato);
    },
  },
};
</script>

<style lang="scss">
</style>
